import * as React from "react";
import type { SVGProps } from "react";
const SvgMute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#mute_svg__a)">
      <path d="M10.21 20.86a1.81 1.81 0 0 1-1.55-.88l-3.15-4.05H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.51l3.16-4A1.84 1.84 0 0 1 11 3.2 1.79 1.79 0 0 1 12 5v13.86a1.79 1.79 0 0 1-1.49 1.98q-.15.025-.3.02M4 9.93v4h2a1 1 0 0 1 .79.39L10 18.44v-13l-3.21 4.1a1 1 0 0 1-.79.39zM20 14.93a1 1 0 0 1-.71-.29L18 13.34l-1.29 1.3a1.004 1.004 0 1 1-1.42-1.42l1.3-1.29-1.3-1.29a1.003 1.003 0 0 1 .326-1.638 1 1 0 0 1 1.094.218l1.29 1.3 1.29-1.3a1.004 1.004 0 0 1 1.42 1.42l-1.3 1.29 1.3 1.29a.999.999 0 0 1-.71 1.71" />
    </g>
    <defs>
      <clipPath id="mute_svg__a">
        <path fill="#fff" d="M2 3h19v17.87H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMute;
